/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_DownloadInputs */

const en_two_fa_recovery_download = /** @type {(inputs: Two_Fa_Recovery_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download codes (.txt)`)
};

const nl_two_fa_recovery_download = /** @type {(inputs: Two_Fa_Recovery_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codes downloaden (.txt)`)
};

/**
* | output |
* | --- |
* | "Download codes (.txt)" |
*
* @param {Two_Fa_Recovery_DownloadInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_download = /** @type {((inputs?: Two_Fa_Recovery_DownloadInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_DownloadInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_download(inputs)
	return en_two_fa_recovery_download(inputs)
});